module.exports = __webpack_public_path__ + "img/C.ab6ce769.svg";